import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Define paths where header and footer should be hidden
const hideOnPaths = [
  '/',
  '/signin',
  '/signup',
  '/signup/legal-professional',
  '/forgot-password',
  '/verify-email',
  '/auth/google-callback',
  '/search',
  '/ask-a-question',
  '/legal-services',
  '/contact',
  '/about'
];

export const useLayoutVisibility = () => {
  const location = useLocation();
  const path = location.pathname;
  // Always set to false to hide header and footer across the application
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    // MODIFIED: Always keep shouldShow as false
    setShouldShow(false);

    // Remove padding on specific pages
    const removePadding = [
      '/signin',
      '/signup',
      '/signup/legal-professional',
      '/solicitor/',
      '/forgot-password',
      '/verify-email',
      '/auth/google-callback'
    ].some(p => path.startsWith(p));

    // Determine body class based on path
    let bodyClass = '';
    if (path === '/signin' || path === '/signup' || path === '/signup/legal-professional' || 
        path === '/forgot-password' || path === '/verify-email' || path === '/auth/google-callback') {
      bodyClass = 'no-scroll';
    } else if (path === '/' || path.startsWith('/solicitor/') || path === '/search' || 
              path === '/ask-a-question' || path === '/legal-services' || 
              path === '/contact' || path === '/about') {
      bodyClass = 'allow-scroll';
    } else {
      bodyClass = '';
    }

    // Apply body class
    document.body.className = bodyClass;
    
    // Cleanup function
    return () => {
      document.body.className = '';
    };
  }, [path]);

  // MODIFIED: Always return false to hide header and footer
  return false;
}; 